import { useEffect, useState } from 'react';
import { getPublicPaymentSettings } from './api';
import type { PaymentSettings } from './api';

export function usePaymentSettings(): {
  settings: PaymentSettings;
  loading: boolean;
  error: string | null;
} {
  const [settings, setSettings] = useState<PaymentSettings>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const res = await getPublicPaymentSettings();
        if (cancelled) return;
        if (res.success && res.data) {
          setSettings(res.data);
        } else {
          setError(res.error?.message || 'Failed to load payment settings');
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : String(err));
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { settings, loading, error };
}

export default usePaymentSettings;
